export default "__VITE_ASSET__BJMh_AEO__"